import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';

import { AuthService } from '../../../../../core/auth/auth.service';

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatRippleModule, NgIf],
})
export class ToolbarUserDropdownComponent {
  private readonly popoverRef = inject(
    VexPopoverRef<ToolbarUserDropdownComponent>,
  );
  private readonly auth = inject(AuthService);

  readonly nombre = computed(() => this.auth.user()?.nombre ?? 'Invitado');
  readonly email = computed(() => this.auth.user()?.email ?? '');
  readonly rol = computed(() => this.auth.user()?.rol ?? '');

  close(): void {
    this.popoverRef.close();
  }

  salir(): void {
    this.popoverRef.close();
    this.auth.logout(true);
  }
}
